import strikeZoneSectors from '../enums/grouped/StrikeZoneSectors.js';

const classifyAsStrike = strikeZoneSectors.inner.zones;

const classifiesAsStrike = function(pitchStrikeZoneSector) {
    if (typeof pitchStrikeZoneSector !== 'string' && typeof pitchStrikeZoneSector !== 'number'){
        return false;
    }

    return classifyAsStrike.indexOf(pitchStrikeZoneSector.toString()) > -1;
};

export default classifiesAsStrike;